import { removeCookieEverywhere } from '../../../utils/cookies';
import { client } from '../../../utils/forstok';

export const destroyUser = async (callback?: () => void) => {
  await client.clearStore();
  removeCookieEverywhere('token');
  removeCookieEverywhere('permission');
  removeCookieEverywhere('password');
  removeCookieEverywhere('users');
  window.sessionStorage.clear();
  window.localStorage.clear();
  callback?.();
};

export const expiredUser = () => {
  return destroyUser(() => {
    window.location.href = '/users/login?k=exp';
  });
};
